export function downloadExcel(ids,HeadOfForm,url,fileName){
    var formData = new FormData();
        let reqArgs = ids
        formData.append("reqArgs",JSON.stringify(reqArgs));
        formData.append("isAsync",'');
        formData.append("dataSourceBeanName",'basicDataSource');
        formData.append("fields",HeadOfForm)
        var oAjax = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        oAjax.open('POST', url, true);
        oAjax.responseType = "blob"; // 返回类型blob
        oAjax.onload = function () {
            if (this.readyState === 4 && this.status === 200) {
               /*  var fileName = fileName; */
                var blob = new Blob([this.response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"});
                var csvUrl = URL.createObjectURL(blob);
                var link = document.createElement('a');
                link.href = csvUrl;
                link.download = fileName;
                link.click();
            } else if( this.status === 500){
                var reader = new FileReader();
                reader.onload = function (event) {
                    var result = JSON.parse(reader.result);
                    self.$coreMethods.message("提示","下载异常");
                };
                reader.readAsText(this.response);
            }else{
                self.$coreMethods.message("提示","下载失败");
            }
        };
        oAjax.send(formData);
    return
  }
